export default "__VITE_ASSET__ldb1I56M__"